
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Group_12567","data-name":"Group 12567","viewBox":"0 0 32 32.074"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"id":"Path_19914","d":"M32 16.037A16 16 0 1 1 16.037 0 16.013 16.013 0 0 1 32 16.037","data-name":"Path 19914","fill":"#ffcc4d"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19915","d":"M17.968 24.955a37.013 37.013 0 0 1-8.5-.97c-.671-.149-1.865 0-1.865 1.865 0 3.8 4.326 8.5 10.368 8.5s10.368-4.7 10.368-8.5c0-1.865-1.268-2.014-1.865-1.865a41.658 41.658 0 0 1-8.5.97","data-name":"Path 19915","transform":"translate(-1.931 -6.083)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19916","d":"M11.4 14.565a1.865 1.865 0 1 1 3.73 0v1.865a1.865 1.865 0 1 1-3.73 0z","data-name":"Path 19916","transform":"translate(-2.897 -3.227)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19917","d":"M26.5 14.565a1.865 1.865 0 1 1 3.73 0v1.865a1.865 1.865 0 1 1-3.73 0z","data-name":"Path 19917","transform":"translate(-6.733 -3.227)"}}),_c('path',{attrs:{"id":"Path_19918","d":"M10.1 26.5a28.951 28.951 0 0 0 8.5.97 28.951 28.951 0 0 0 8.5-.97s-1.865 3.8-8.5 3.8-8.5-3.8-8.5-3.8","data-name":"Path 19918","transform":"translate(-2.566 -6.733)","fill":"#fff"}})])
          )
        }
      }
    